import { DotsThreeCircleVerticalIcon } from '@phosphor-icons/react'

import { ButtonMenu, IconButton } from '@reveni-io/reveni-ui'

import { actionsReasons } from '@/returns/pages/TransactionDetailPage/constants'

import AddTrackingNumberTitle from './AddTrackingNumberTitle/AddTrackingNumberTitle'
import ChangeDeliveryMethodTitle from './ChangeDeliveryMethodTitle/ChangeDeliveryMethodTitle'
import EditAddressTitle from './EditAddressTitle/EditAddressTitle'
import RequestLabelTitle from './RequestLabelTitle/RequestLabelTitle'
import SchedulePickupTitle from './SchedulePickupTitle/SchedulePickupTitle'
import SendInstructionsTitle from './SendInstructionsTitle/SendInstructionsTitle'
import { actions } from './constants'

const ReturnShippingMenu = ({
  allowsGenerateLabelReason,
  allowsSchedulePickupReason,
  onGenerateLabel,
  onSchedulePickup,
  onEditAddress,
  pickupScheduled,
  onAddTrackingNumber,
  onSendInstructions,
  onChangeDeliveryMethod,
  isSchedulePickupDisabled,
  allowsEditReturnLabels,
  isDisabledForOnHoldAndPendingStatus,
  allowsMarkAsShipped,
  allowsReturnInstructionsRequest,
  allowsUpdateDeliveryMethod,
  allowsUpdateAddress,
}) => {
  const isRequestLabelDisabled = [actionsReasons.pickupScheduled, actionsReasons.maxReturnLabels].includes(
    allowsGenerateLabelReason
  )

  const options = [
    {
      label: (
        <SchedulePickupTitle
          isDisabled={isSchedulePickupDisabled}
          pickupScheduled={pickupScheduled}
          allowsSchedulePickupReason={allowsSchedulePickupReason}
        />
      ),
      disabled: isSchedulePickupDisabled,
      onClick: onSchedulePickup,
      value: actions.schedulePickup,
      visible: !isDisabledForOnHoldAndPendingStatus,
    },
    {
      label: (
        <RequestLabelTitle
          allowsGenerateLabelReason={allowsGenerateLabelReason}
          isDisabled={isRequestLabelDisabled}
          pickupScheduled={pickupScheduled}
        />
      ),
      disabled: isRequestLabelDisabled,
      onClick: onGenerateLabel,
      value: actions.generateLabel,
      visible: !isDisabledForOnHoldAndPendingStatus,
    },
    {
      label: <EditAddressTitle />,
      disabled: !allowsUpdateAddress,
      onClick: onEditAddress,
      value: actions.editAddress,
      visible: true,
    },
    {
      label: <AddTrackingNumberTitle />,
      disabled: !allowsMarkAsShipped || !allowsEditReturnLabels,
      onClick: onAddTrackingNumber,
      value: actions.addTrackingNumber,
      visible: !isDisabledForOnHoldAndPendingStatus,
    },
    {
      label: <SendInstructionsTitle />,
      disabled: !allowsReturnInstructionsRequest || !allowsEditReturnLabels,
      onClick: onSendInstructions,
      value: actions.addTrackingNumber,
      visible: !isDisabledForOnHoldAndPendingStatus,
    },
    {
      label: <ChangeDeliveryMethodTitle />,
      disabled: !allowsUpdateDeliveryMethod || !allowsEditReturnLabels,
      onClick: onChangeDeliveryMethod,
      value: actions.changeDeliveryMethod,
      visible: allowsUpdateDeliveryMethod,
    },
  ].filter(option => {
    if (option.value === actions.schedulePickup && allowsSchedulePickupReason === actionsReasons.notSupported) {
      return false
    }

    if (option.value === actions.generateLabel && allowsGenerateLabelReason === actionsReasons.notSupported) {
      return false
    }

    return option.visible
  })

  return (
    <ButtonMenu
      renderButton={onOpen => (
        <IconButton
          onClick={onOpen}
          variant="text"
          icon={<DotsThreeCircleVerticalIcon data-testid="menuButton" size={24} />}
        />
      )}
      menuItems={options}
    />
  )
}

export default ReturnShippingMenu
